import { v4 as uuidv4 } from 'uuid';
import React from 'react';
import {
  BrowserRouter as Router, Route, Switch, Redirect,
} from 'react-router-dom';
import { render } from 'react-dom';
import { applyMiddleware, createStore, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Provider } from 'react-redux';
import { analytics } from '@sendgrid/bloodhound';

import reducer from './reducers';
import { telemetry } from './utils/telemetry';
import LoadAnalytics from './utils/Analytics';
import getEnvVariable from './utils/environment';
import { getCookie, setCookie } from './utils/cookieHelpers';
import { LOCALSTORAGE, ENVIRONMENT, COOKIES } from './constants';

import Account from './pages/Account';
import Billing from './pages/Billing';
import Profile from './pages/Profile';
// import AdsProfile from './pages/AdsProfile';
import Declined from './pages/Declined';
// import Ads from './pages/Ads';
import RouteChangeDetector from './components/RouteChangeDetector';
import { eHawkTalon } from './vendor/eHawkTalon';

import './index.scss';

// initialize Sentry
telemetry.load();

// generate browser fingerprint
eHawkTalon();

// eslint-disable-next-line
const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
// only use dev tools if available and env is 'development'
const composeEnhancers = (process.env.NODE_ENV === 'development' && reduxDevTools) || compose;

const store = createStore(reducer, composeEnhancers(applyMiddleware(thunkMiddleware)));

store.subscribe(() => {
  const { addOns, packages } = store.getState();
  localStorage.setItem(LOCALSTORAGE.REDUX_STATE, JSON.stringify({
    addOns,
    packages,
  }));
});

const redirectToAdsMarketingPage = () => {
  window.location.href = 'https://sendgrid.com/solutions/ads/';
};

LoadAnalytics(getEnvVariable(ENVIRONMENT.SEGMENT_KEY));

// This is a temporary solution used to bucket users for Signup experiments
let experimentToken = getCookie(COOKIES.EXPERIMENT_TOKEN);
if (!experimentToken) {
  experimentToken = uuidv4();
  setCookie(COOKIES.EXPERIMENT_TOKEN, experimentToken);
}
analytics.identify({
  traits: {
    experimentToken,
  },
});

render(
  <Provider store={store}>
    <Router>
      <RouteChangeDetector>
        <Switch>
          <Route path="/account_details" component={Profile} />
          <Route path="/ads/account_details" render={redirectToAdsMarketingPage} />
          <Route path="/billing" component={Billing} />
          <Route path="/ads/billing" render={redirectToAdsMarketingPage} />
          <Route path="/declined" component={Declined} />
          <Route path="/ads" render={redirectToAdsMarketingPage} />
          <Route path="/" component={Account} />
          <Redirect to="/" />
        </Switch>
      </RouteChangeDetector>
    </Router>
  </Provider>,
  document.getElementById('root'),
);
